export default function () {
    const $toggleButton = $('#toggle-survey-metadata');
    const storedEnableMetadata = localStorage.getItem("enableMetadata");
    const defaultEnableMetadata = $toggleButton.is(':checked');

    // local storage converts bool to string
    const enabled = storedEnableMetadata !== null ? storedEnableMetadata === "true" : defaultEnableMetadata;

    setMetadataEnabled(enabled);

    $toggleButton.siblings('.toggle-btn-knob').removeClass('visually-hidden');

    $toggleButton.on('click', function () {
        setMetadataEnabled($toggleButton.is(':checked'));
    });

    function setMetadataEnabled(enabled: boolean) {
        const $metadataElements = $('.metadata');
        if (enabled) {
            $toggleButton.prop('checked', true);
            $metadataElements.removeClass('visually-hidden');
        } else {
            $toggleButton.prop('checked', false);
            $metadataElements.addClass('visually-hidden');
        }
        try {
            // Ignore storage error: https://github.com/cloud-solutions/surveylab/issues/666
            localStorage.setItem("enableMetadata", enabled ? "true" : "false");
        } catch (error) {
        }

    }
}
